import { render } from "./DistrictView.vue?vue&type=template&id=f8749e82"
import script from "./DistrictView.vue?vue&type=script&lang=js"
export * from "./DistrictView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__